export default __webpack_public_path__ + "static/media/ch_2.d18ce8e9.mp3";